<template>
  <div id="app">
    <timeout></timeout>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :on-cancel="onCancel"
      :is-full-page="true"
    ></loading>
    <router-view></router-view>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Timeout from "./Timeout.vue";
export default {
  name: "App",
  components: {
    Loading,
    Timeout,
  },
  methods: {
    onCancel() {
      console.log("User cancelled the loader.");
    },
  },
  created() {
    DataTableEventBus.$on("editData", (data) =>
      console.log("editing " + data.id)
    );
    DataTableEventBus.$on("viewData", (data) =>
      console.log("showing " + data.id)
    );
    DataTableEventBus.$on("deleteData", (data) =>
      console.log("deleting " + data.id)
    );
  },
  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
    parameters() {
      return {
        data: this.users,
        actionColumn: true,
        columns: this.keys.map((key) => ({ key })),
      };
    },
  },
  data() {
    return {
      keys: ["name", "email", "gender", "country", "job", "city", "created_at"],
    };
  },
};
</script>
    


// WEBPACK FOOTER //
// src/App.vue